import { BaseWorkflowActivityAssignmentViewModel } from "../base-workflow-activity-assignment";
import { autoinject, computedFrom } from "aurelia-framework";
import { Reflection } from "../../../../utilities/reflection";

@autoinject()
export class ActivityAssignment extends BaseWorkflowActivityAssignmentViewModel {

    configMeta: any;

    @computedFrom(
        Reflection.getPropertyPath<ActivityAssignment>(x => x.configMeta),
        Reflection.getPropertyPath<ActivityAssignment>(x => x.item)
    )
    get email(): string {
        return this.configMeta.isFreeAddress ? this.configMeta.email : this.item[this.configMeta.email];
    }

    onActivated() {
        this.configMeta = JSON.parse(this.assignment.configMeta);
        this.assignment.assignmentState.showStatus = false;
        this.assignment.assignmentState.isSystemAssignment = true;
    }
}
